import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import { Box, ListItemButton, Typography } from "@mui/material";
import { useHistory } from "react-router-dom";
import { AuthContext } from "../context/auth";

export const deleteJwtCookie = (path = "/") => {
  const hostname = window.location.hostname;
  const domain = hostname.replace("mmaz", "");
  const cookieString = `${
    process.env.REACT_APP_MCZTOKEN_COOKIE
  }=; Expires=Thu, 01 Jan 1970 00:00:00 UTC; Path=${path};${
    domain ? ` Domain=${domain};` : ""
  }`;
  document.cookie = cookieString;
  document.cookie = cookieString + " Secure;";
  document.cookie = cookieString + " SameSite=None;";
};

export default function NavigationItem({ page, onOptionSelect }: any) {
  const history = useHistory();
  const { setUser, setJwt } = useContext(AuthContext);
  const isActive = Boolean(page.open);

  const handleLogout = () => {
    if (onOptionSelect) onOptionSelect();
    deleteJwtCookie();
    setUser(undefined);
    setJwt("");
    history.push("/");
  };

  const handleClick = () => {
    if (onOptionSelect) onOptionSelect();
    history.push(page.path);
  };

  const itemSx = {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    px: "12px",
    py: "9px",
    mx: "10px",
    my: "2px",
    borderRadius: "8px",
    minHeight: "38px",
    borderLeft: "2px solid transparent",
    backgroundColor: isActive ? "rgba(99, 102, 241, 0.09)" : "transparent",
    color: isActive ? "#a5b4fc" : "rgba(255,255,255,0.52)",
    transition: "all 0.15s ease",
    "&:hover": {
      backgroundColor: isActive
        ? "rgba(99, 102, 241, 0.14)"
        : "rgba(255,255,255,0.04)",
      color: isActive ? "#a5b4fc" : "rgba(255,255,255,0.78)",
    },
  };

  const content = (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexShrink: 0,
          "& svg": {
            fontSize: "17px",
            color: isActive ? "#818cf8" : "rgba(255,255,255,0.32)",
            transition: "color 0.15s ease",
          },
        }}
      >
        {page.icon}
      </Box>
      <Typography
        sx={{
          fontSize: "13px",
          fontWeight: isActive ? 600 : 400,
          letterSpacing: "0.01em",
          lineHeight: 1,
          color: "inherit",
        }}
      >
        {page.name}
      </Typography>
    </>
  );

  if (page?.external) {
    return (
      <a href={page.path} target="_blank" style={{ textDecoration: "none" }}>
        <ListItemButton sx={itemSx}>{content}</ListItemButton>
      </a>
    );
  } else if (page?.function === "logout") {
    return (
      <ListItemButton onClick={handleLogout} sx={itemSx}>
        {content}
      </ListItemButton>
    );
  } else {
    return (
      <NavLink to={page.path} style={{ textDecoration: "none" }}>
        <ListItemButton onClick={handleClick} sx={itemSx}>
          {content}
        </ListItemButton>
      </NavLink>
    );
  }
}
